module.exports = __webpack_public_path__ + "static/messages-8ab88a6a62537b1a2bc1249bf61cbd4f.png";